module.exports = __webpack_public_path__ + "img/digital_space_bg_top.c033375c.svg";